import { HeroVariant } from './HeroVariant';

interface HeroVariantsGridProps {
  variants: Array<{
    id: number;
    description: string;
    html: string;
  }> | null;
  onSelect: (variant: { id: number; description: string; html: string }) => void;
  selectedId?: number;
}

export const HeroVariantsGrid: React.FC<HeroVariantsGridProps> = ({ 
  variants, 
  onSelect,
  selectedId 
}) => (
  <div className="grid grid-cols-1 gap-3 overflow-hidden">
    {variants?.map(variant => (
      <HeroVariant
        key={variant.id}
        variant={variant}
        onSelect={onSelect}
        isSelected={variant.id === selectedId}
      />
    ))}
  </div>
);
